import type { AxiosResponse } from 'axios'
import type { FolderList } from '../model/folderModel'
import type {
  FolderMasterListResponse,
  PutFolderMoveModel,
  PutFolderUserApi,
} from './model'

import { bffHTTP } from '@/utils/http/axios'
import { handleAPIException } from '@/utils/exception'
import { ApiResponseStatusEnum, HTTPMethodsEnum } from '@/enums'

// 利用者情報一覧api
export async function getData(): Promise<any | undefined> {
  try {
    const response: AxiosResponse<any, any> = await bffHTTP({
      method: HTTPMethodsEnum.GET,
      url: '/folders',
    })

    handleAPIException(response)
    return response.data
  } catch (error) {
    console.log('getData', error)
  }
}

export async function putData(params: any): Promise<any | undefined> {
  try {
    const response: AxiosResponse<any, any> = await bffHTTP({
      method: HTTPMethodsEnum.PUT,
      url: '/folders',
      data: params,
    })

    handleAPIException(response)
    return response
  } catch (error) {
    console.log('putData', error)
  }
}

export async function getUsersData(params: number): Promise<any | undefined> {
  try {
    const response: AxiosResponse<any, any> = await bffHTTP({
      method: HTTPMethodsEnum.GET,
      url: '/folders/' + params + '/users',
    })

    handleAPIException(response)
    return response.data
  } catch (error) {
    console.log('getUsersData', error)
  }
}

export async function putUsersData(params: PutFolderUserApi): Promise<boolean> {
  try {
    const response: AxiosResponse<PutFolderUserApi, null> = await bffHTTP({
      method: HTTPMethodsEnum.PUT,
      url: '/corporates/folders/users',
      data: params,
    })

    handleAPIException(response)
    return true
  } catch (error) {
    console.log('putUsersData', error)
    return false
  }
}

/**
 * @description フォルダと送信先取得 API
 * @returns フォルダ情報リスト
 */
export async function getFolderMasterList(): Promise<FolderList> {
  try {
    const response: AxiosResponse<FolderMasterListResponse, null> = await bffHTTP({
      method: HTTPMethodsEnum.GET,
      url: '/folders',
    })

    handleAPIException(response)
    return response.data.detail ?? []
  } catch (error) {
    console.warn('folderMasterListResponse', error)
    return []
  }
}

/**
 * @description フォルダ移行 API
 * @param fromFolderId 移行元フォルダ選択されたID
 * @param toFolderId 移行先フォルダ選択されたID
 * @returns 移行成功か否か
 */
export async function putFolderMove(
  fromFolderId: number | undefined,
  toFolderId: number | undefined
): Promise<boolean> {
  try {
    const response: AxiosResponse<PutFolderMoveModel, any> = await bffHTTP({
      method: HTTPMethodsEnum.PUT,
      url: '/folder/products/transfer',
      data: { from_folder_id: fromFolderId, to_folder_id: toFolderId },
    })

    handleAPIException(response)
    return response.status === ApiResponseStatusEnum.SUCCESSFUL_STATUS
  } catch (error) {
    console.warn('putFolderMove', error)
    return false
  }
}
